import React from "react";
import HeroSection from "../Components/HeroSection";
import { GiCheckMark } from "react-icons/gi";
import { Helmet } from "react-helmet";

function AboutUs() {
  return (
		<>
			<Helmet>
				<title>About Us | University of Education</title>
			</Helmet>
			<div className="PageContainer">
				<section>
					<HeroSection />
				</section>

				<section>
					<div className="AboutUs">
						<div id="Heading" data-aos="fade-up">
							<h1>About Us</h1>
						</div>

						<div className="AboutDesc" data-aos="fade-up">
							<p data-aos="fade-up">
								The University Department of Education, functioning under Vinoba Bhave University, Hazaribagh, is a premier centre for teacher education in Jharkhand. 
                                Established with a vision to nurture competent and dedicated educators, the department offers specialized programs in education, including the 
                                <b> Master of Education (M.Ed.)</b> and the <b>4-year Integrated B.A./B.Sc.-B.Ed.</b> course.
							</p>
							<br />

							<p data-aos="fade-up">
								Located in the serene surroundings of Hazaribagh, the department provides an ideal environment for academic pursuits and professional growth. 
                                It is committed to setting high standards in teacher education through a curriculum that blends theoretical knowledge with practical teaching skills. 
                                As a part of Vinoba Bhave University, which was established in 1992, the department benefits from a rich academic legacy and resources.
							</p>
							<br />

							<p data-aos="fade-up">
 The department boasts a team of highly qualified and experienced faculty members who guides students through rigorous academic training and research activities. 
                                The infrastructure includes well-equipped classrooms, a modern library, educational technology labs, and resource centers that cater to the diverse needs of aspiring teachers.
							</p>
							<br />

							<p data-aos="fade-up">
								Our mission is to produce educators who are not only subject matter experts but also socially responsible and ethically grounded. 
                                By integrating modern pedagogical techniques with traditional values, we aim to shape the future of education in the region and beyond.
							</p>
							<br />

							<p data-aos="fade-up">
								<b>
									Key Features of the University Department of Education:
								</b>
							</p>
							<br />
						</div>

						<div className="AboutList" data-aos="fade-up">
							<ul>
								<table>
									<tr>
										<li data-aos="fade-up">
											<td>
												<GiCheckMark className="check-icon" />
											</td>
											<td>Functioning under Vinoba Bhave University (Est. 1992)</td>
										</li>
									</tr>
									<tr>
										<li data-aos="fade-up">
											<td>
												<GiCheckMark className="check-icon" />
											</td>
											<td>Located in Hazaribagh, Jharkhand, India</td>
										</li>
									</tr>
									<tr>
										<li data-aos="fade-up">
											<td>
												<GiCheckMark className="check-icon" />
											</td>
											<td>
												Recognized by the National Council for Teacher Education (NCTE) & UGC
											</td>
										</li>
									</tr>
									<tr>
										<li data-aos="fade-up">
											<td>
												<GiCheckMark className="check-icon" />
											</td>
											<td>
												Strong focus on Teacher Education and Educational Research
											</td>
										</li>
									</tr>
									<tr>
										<li data-aos="fade-up">
											<td>
												<GiCheckMark className="check-icon" />
											</td>
											<td>
												Offers M.Ed. and Integrated B.A./B.Sc.-B.Ed. Programs
											</td>
										</li>
									</tr>
									<tr>
										<li data-aos="fade-up">
											<td>
												<GiCheckMark className="check-icon" />
											</td>
											<td>Qualified and Experienced Faculty Members</td>
										</li>
									</tr>
									<tr>
										<li data-aos="fade-up">
											<td>
												<GiCheckMark className="check-icon" />
											</td>
											<td>
												Well-equipped with modern facilities including Library and Labs
											</td>
										</li>
									</tr>
									<tr>
										<li data-aos="fade-up">
											<td>
												<GiCheckMark className="check-icon" />
											</td>
											<td>
												Commitment to holistic student development
											</td>
										</li>
									</tr>
								</table>
							</ul>
						</div>
					</div>
				</section>
			</div>
		</>
	);
}

export default AboutUs;
